/**
 * @generated SignedSource<<afe953a9bd8335f4d97d24c69a64880b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion$data = {
  readonly id: string;
  readonly issuesForList: {
    readonly edges: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges" | "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference" | "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference">;
    } | null | undefined>;
    readonly jql: string | null | undefined;
    readonly totalCount: number | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"emptyView_softwareReleasesVersionDetailIssueList" | "issues_softwareReleasesVersionDetailIssueList_jiraVersion" | "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch" | "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference">;
  readonly " $fragmentType": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion";
};
export type ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion$key = {
  readonly " $data"?: ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion">;
};

import verionDetailsIssueListQuery_graphql from './verionDetailsIssueListQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "issuesForList"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "filters"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    },
    {
      "kind": "RootArgument",
      "name": "shouldIncludeDevOpsFieldsViaAgs"
    },
    {
      "kind": "RootArgument",
      "name": "sortBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": verionDetailsIssueListQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion"
    },
    {
      "kind": "FragmentSpread",
      "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
    },
    {
      "kind": "FragmentSpread",
      "name": "emptyView_softwareReleasesVersionDetailIssueList"
    },
    {
      "kind": "FragmentSpread",
      "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "issuesForList",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
          },
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
          },
          {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "__ListVersion_issuesForList_connection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "totalCount"
          },
          {
            "kind": "ScalarField",
            "name": "jql"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraIssueEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference"
                },
                {
                  "kind": "ScalarField",
                  "name": "cursor"
                },
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "issuesForList.edges"
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "issuesForList"
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "1a52a23b324242e6dd47774f54758481";

export default node;
